import React from "react";
import {Typography, TypographyProps} from "@mui/material";

interface TextProps extends Pick<TypographyProps & React.ComponentProps<typeof Typography>, 'color' | 'variant' | 'component' | 'sx' | 'fontSize' | 'onClick'> {

}

export interface IHightlightProps {
    input: string;
    search: string;
    options: {
        minLenght: number;
    };
    normalText?: TextProps;
    highlightText?: TextProps;
}


export function HighlightText({
                                  input, search, options = {
        minLenght: 2,
    }, normalText = {
        component: 'span',
        sx: {
            whiteSpace: 'pre-wrap',
            display: 'inline',
        },
    }, highlightText = {
        component: 'span',
        sx: {
            whiteSpace: 'pre-wrap',
            display: 'inline',
            fontWeight: 800,
        },
        color: 'info',
    }
                              }: IHightlightProps) {

    const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const terms = search
        .split(/\s+/)
        .map(t => t.trim())
        .filter(x => x.length > options.minLenght)
        .filter(Boolean);

    if (terms.length == 0) {
        return [<Typography key={0} {...normalText}>{input}</Typography>] as React.ReactNode[]
    }


    const pattern = new RegExp(`(${terms.map(escapeRegExp).join('|')})`, 'ig');

    const parts = input.split(pattern);
    return parts.map((part, idx) => {
        if (part === null || part === undefined) return null;
        // Mantém exatamente o conteúdo (inclui espaços se estiverem nos fragments adjacentes)
        const isMatch = terms.some(t => part.toLowerCase() === t.toLowerCase());
        if (isMatch) {
            return (
                <Typography {...highlightText} key={`m-${idx}`}>
                    {part}
                </Typography>
            );
        }
        return (
            <Typography key={`m-${idx}`} {...normalText}>
                {part}
            </Typography>
        );
    }).filter(Boolean) as React.ReactNode[];
}